import { useForm } from "react-hook-form";
import React, { useState } from "react";
import { FormSubmitButton } from "@/components/base/ui/FormSubmitButton";
import { TacticQuiz } from "@/types/tacticQuiz";
import { useToast } from "@/utils";
import { newAttendanceTacticRepository } from "@/repositories/attendanceTactic";
import { client } from "@/api/client";
import { useSWRConfig } from "swr";

export const Quiz = ({
  tactic_id,
  quizzes,
  experience_point,
  tactic_quizzes_count,
  is_attended,
}: {
  tactic_id: string;
  quizzes: TacticQuiz[];
  experience_point: number;
  tactic_quizzes_count: number;
  is_attended: boolean;
}) => {
  const toast = useToast();
  const { mutate } = useSWRConfig();
  const [loading, setLoading] = useState(false);
  const attendanceTacticRepository = newAttendanceTacticRepository(client);

  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      const answers = Object.entries(data);
      const saveData = {
        tactic_id,
        tactic_quizzes: answers.map((answer) => {
          return {
            id: answer[0],
            answer: Number(answer[1]),
          };
        }),
      };
      await attendanceTacticRepository.createAttendanceTactic(saveData);
      toast.success(`正解です！経験値:${experience_point}を獲得しました！`);
      await mutate(`/api/v1/tactics/${tactic_id}`);
    } catch (e) {
      if (e === 406) {
        toast.error("回答が間違っています。");
      } else {
        toast.error("エラーが発生しました。");
      }
    } finally {
      setLoading(false);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <div className={""}>
      <p className={"bg-gray-100 px-3 py-4 font-bold mt-7 mb-6 text-lg"}>
        {is_attended
          ? "受講済み"
          : `全${tactic_quizzes_count}問（全問正解で受講完了）`}
      </p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          {quizzes?.map((quiz, index) => (
            <div key={index}>
              {is_attended ? (
                <>
                  {quiz.commentary && (
                    <div className={`mt-5`}>
                      <p className={"mb-6"}>Q. {quiz.title}</p>
                      <div className={"relative"}>
                        <p
                          className={
                            "absolute top-[-15px] left-2 rounded-[15px] font-bold text-sm text-white bg-blue-700 leading-none px-3 py-2"
                          }
                        >
                          解説
                        </p>
                        <p className={"border border-blue-700 px-3 pt-5 pb-3"}>
                          {quiz.commentary}
                        </p>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className={`mt-8`}>
                  <p className={"mb-2"}>Q. {quiz.title}</p>
                  <div className={"pl-4"}>
                    <div className={"mb-2"}>
                      <input
                        className={"mr-2 cursor-pointer"}
                        type="radio"
                        id={`q-${index}-option-1`}
                        value="1"
                        {...register(quiz.id, { required: true })}
                      />
                      <label
                        className={"cursor-pointer"}
                        htmlFor={`q-${index}-option-1`}
                      >
                        {quiz.option1}
                      </label>
                    </div>
                    <div className={"mb-2"}>
                      <input
                        className={"mr-2 cursor-pointer"}
                        type="radio"
                        id={`q-${index}-option-2`}
                        value="2"
                        {...register(quiz.id, { required: true })}
                      />
                      <label
                        className={"cursor-pointer"}
                        htmlFor={`q-${index}-option-2`}
                      >
                        {quiz.option2}
                      </label>
                    </div>
                    <div className={"mb-2"}>
                      <input
                        className={"mr-2 cursor-pointer"}
                        type="radio"
                        id={`q-${index}-option-3`}
                        value="3"
                        {...register(quiz.id, { required: true })}
                      />
                      <label
                        className={"cursor-pointer"}
                        htmlFor={`q-${index}-option-3`}
                      >
                        {quiz.option3}
                      </label>
                    </div>
                    <div>
                      <input
                        className={"mr-2 cursor-pointer"}
                        type="radio"
                        id={`q-${index}-option-4`}
                        value="4"
                        {...register(quiz.id, { required: true })}
                      />
                      <label
                        className={"cursor-pointer"}
                        htmlFor={`q-${index}-option-4`}
                      >
                        {quiz.option4}
                      </label>
                    </div>
                    {Object.keys(errors).includes(quiz.id) && (
                      <span className={"block text-red-500 mt-2 text-sm"}>
                        {"回答は必須です。"}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        {!is_attended && (
          <div className={"mt-10"}>
            <FormSubmitButton loading={loading}>回答する</FormSubmitButton>
          </div>
        )}
      </form>
    </div>
  );
};
